import React, { useMemo } from 'react';
import { buildHammerLegs } from '../../utils/hammerUrls';
import '../../styles/HammerLinks.css';

/**
 * Deep links to the Hammer truck GPS app (max 5 waypoints per leg).
 * @param {{ depot?: object, stops?: object[], compact?: boolean }} props
 */
const HammerRouteLinks = ({ depot, stops, compact = false }) => {
  const legs = useMemo(() => buildHammerLegs(depot, stops), [depot, stops]);

  if (!legs.length) {
    return (
      <p className="hammer-links hammer-links--empty">
        Add stops with addresses or coordinates to open routes in Hammer.
      </p>
    );
  }

  return (
    <div className={`hammer-links ${compact ? 'hammer-links--compact' : ''}`}>
      <div className="hammer-links-row">
        <span className="hammer-links-title">Open in Hammer</span>
        {legs.map((leg) => (
          <a
            key={leg.index}
            href={leg.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-hammer"
            title={`${leg.waypointCount} waypoints — opens Hammer app on your phone`}
          >
            Leg {leg.index}
            {leg.viaLabel ? <span className="btn-hammer-meta"> ({leg.viaLabel})</span> : null}
          </a>
        ))}
      </div>
      {!compact && (
        <p className="hammer-links-hint">
          Opens the Hammer truck GPS app (mobile). Boxed keeps the official stop order; use the same
          sequence when driving. Routes with more than four deliveries after the depot are split into
          legs (up to five waypoints each).
        </p>
      )}
    </div>
  );
};

export default HammerRouteLinks;
